import {
  localReducer,
  localReduxFind,
  localReduxInsert,
  localReduxRemove,
} from '@weblite/persist'

export function createLocalStorage<T>(collection: string) {
  const storage = {
    set(data: T) {
      localReduxInsert(collection, data)
    },
    del() {
      localReduxRemove(collection)
    },
    get(): T | undefined {
      return localReduxFind(collection)
    },
  }

  const reducer = localReducer(['main', collection])

  return [storage, reducer] as [typeof storage, typeof reducer]
}
